import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail, ArrowLeft, ShieldCheck, Users } from 'lucide-react';
import { ASSETS } from '../mock/data';
import { useApp } from '../context/AppContext';

const StaffLogin = () => {
  const nav = useNavigate();
  const { login } = useApp();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setLoading(true);
    try {
      const u = await login({ email, password });
      if (u.role !== 'staff' && u.role !== 'admin') { setErr('You are not authorised as staff'); return; }
      localStorage.setItem('c24_staff', JSON.stringify({ email, role: u.role, loggedInAt: new Date().toISOString() }));
      nav('/staff');
    } catch (ex) {
      setErr(ex.response?.data?.detail || 'Invalid staff credentials');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-neutral-100 flex items-center justify-center px-5">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg overflow-hidden">
        <div className="px-6 pt-6">
          <button onClick={() => nav('/')} className="text-sm text-neutral-500 hover:text-neutral-900 inline-flex items-center gap-1">
            <ArrowLeft className="w-4 h-4" /> Back to site
          </button>
        </div>
        <div className="px-6 pt-4 pb-8">
          <div className="bg-[#1E88E5] rounded-xl p-4 inline-flex items-center gap-3">
            <div className="bg-white rounded p-1">
              <img src={ASSETS.logo} className="h-10" alt="Clean24" />
            </div>
            <div>
              <p className="text-white font-bold text-sm">Clean24 Staff Portal</p>
              <p className="text-white/80 text-xs">Supervisor & operations login</p>
            </div>
          </div>

          <h1 className="mt-5 text-2xl font-extrabold text-neutral-900">Staff / Supervisor login</h1>
          <p className="text-sm text-neutral-500 mt-1">Manage cleaners, monitor jobs & attendance.</p>

          {err && <div className="mt-4 p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg">{err}</div>}

          <form onSubmit={submit} className="mt-5 space-y-3">
            <div className="relative">
              <Mail className="w-4 h-4 text-neutral-400 absolute left-4 top-1/2 -translate-y-1/2" />
              <input type="email" required placeholder="staff@clean24.com" value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-11 pr-4 py-3 rounded-xl border border-neutral-200 bg-white focus:outline-none focus:border-[#1E88E5] focus:ring-2 focus:ring-[#1E88E5]/20 text-sm" />
            </div>
            <div className="relative">
              <Lock className="w-4 h-4 text-neutral-400 absolute left-4 top-1/2 -translate-y-1/2" />
              <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-11 pr-4 py-3 rounded-xl border border-neutral-200 bg-white focus:outline-none focus:border-[#1E88E5] focus:ring-2 focus:ring-[#1E88E5]/20 text-sm" />
            </div>

            <button type="submit" disabled={loading} className="w-full py-3 rounded-xl bg-[#1E88E5] hover:bg-[#1976D2] disabled:opacity-70 text-white font-semibold transition-colors">
              {loading ? 'Signing in...' : 'Sign in as Staff'}
            </button>
          </form>

          {/* Demo credential display removed (security policy 2026-02) */}

          <div className="mt-4 pt-4 border-t border-neutral-100 text-center text-xs text-neutral-500">
            Are you a super admin? <button onClick={() => nav('/admin/login')} className="text-[#2E7D32] font-semibold hover:underline">Admin login</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffLogin;
